export const INFO_SCREEN = 'info-screen';
export const HOPE_SEE_YOU_AGAIN_SCREEN = 'hope-to-see-you-again';
export const TELL_US_WHY = 'tell-us-why';
export const TRY_AGAIN_SCREEN = 'please-try-again';
export const CHECKING_TRIPS = 'checking-trips';
export const UNIVERSAL_PROFILE_SETTINGS_URL = '/account/settings';
